import { db } from '@/firebaseConfig'
import { Capacitor } from '@capacitor/core'

export default {
  state: {
    loading: false,
    error: null,
    info: null,
    snackbar: {}
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload
    },
    clearLoading(state) {
      state.loading = false
    },
    setError(state, payload) {
      state.error = payload
    },
    clearError(state) {
      state.error = null
    },
    setInfo(state, info) {
      state.info = info
    },
    clearInfo(state) {
      state.info = null
    },
    setSnackbar(state, payload) {
      state.snackbar = payload
    },
    clearSnackbar(state) {
      state.snackbar = {}
    }
  },
  actions: {
    onContactUs({ _ }, payload) {
      return new Promise((resolve, reject) => {
        db.collection('contact_us_messages').doc().set(payload)
          .then(() => {
            resolve()
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  },
  getters: {
    loading(state) {
      return state.loading
    },
    error(state) {
      return state.error
    },
    info(state) {
      return state.info
    },
    snackbar(state) {
      return state.snackbar
    },
    isRunningOnWeb() {
      return Capacitor.getPlatform() === 'web'
    }
  }
}
